import React, { useEffect, useState } from 'react';
import './EditorPage.css';
import { useSearchParams } from 'react-router-dom';
import { getWebsiteLookupDataFromUrl } from '../utils/api/website.utils';
import StudioEditor from '@grapesjs/studio-sdk/react';
import '@grapesjs/studio-sdk/style';

type PageDef = { id: string; name: string; html: string };
const TEMPLATES: PageDef[] = [{ id: 'home', name: 'Home', html: '/templates/template1.html' }];

const EditorPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const { websiteId, websiteState, websiteType } = getWebsiteLookupDataFromUrl(searchParams);

  const [pages, setPages] = useState<any[] | null>(null);

  useEffect(() => {
    let alive = true;
    const loadText = (url: string) =>
      fetch(url, { cache: 'no-store' }).then(r => {
        if (!r.ok) throw new Error(`Failed to load ${url}`);
        return r.text();
      });

    (async () => {
      const loaded = await Promise.all(
        TEMPLATES.map(async t => ({
          id: t.id,
          name: t.name,
          component: await loadText(t.html), // HTML string for the page
        }))
      );
      if (alive) setPages(loaded);
    })().catch(err => {
      console.error(err);
      if (alive) setPages([]); // avoid hanging UI
    });

    return () => {
      alive = false;
    };
  }, []);

  if (!websiteId || !websiteState || !websiteType) {
    return <div>No website id, state or type</div>;
  }

  if (!pages) return null; // or a spinner

  // @ts-ignore
  // @ts-ignore
  // @ts-ignore
  return (
    <div className="editor-page">
      <StudioEditor
        options={{
          project: {
            type: 'web',
            id: 'my-project-v4',
            default: { pages },
          },
          theme: 'dark',
          customTheme: {
            default: {
              colors: {
                global: {
                  // Make the global text color red
                  text: 'white',
                },
              },
            },
          },
          layout: {
            default: {
              type: 'row',
              style: { height: '100%' },
              children: [
                {
                  type: 'canvasSidebarTop',
                  sidebarTop: {
                    style: { height: 100 },
                    leftContainer: {
                      buttons: ({ items }: { items: any[] }) => [
                        {
                          ...items.find((item: any) => item.id === 'blocks-Blocks'),
                          label: 'Add components',
                          style: { backgroundColor: 'white', color: 'black' },
                        },
                      ],
                    },
                    rightContainer: {
                      buttons: ({ items }: { items: any[] }) =>
                        items.map(btn =>
                          btn.id === 'componentOutline'
                            ? { ...btn, label: 'Toggle outline', style: { backgroundColor: 'blue' } } // rename only this one
                            : btn
                        ),
                      // Keep just what you want; gear won’t be here
                      // buttons: ({ items }: { items: any[] }) => items.filter((i: any) => i.id !== 'componentOutline'),
                    },
                  },
                },
              ],
            },
          },
          plugins: [
            (editor: any) => {
              editor.on('load', async () => {
                // 2) Add your form block
                const html = await (await fetch('/forms/form-1.html')).text();
                editor.BlockManager.add('form-1', {
                  label: 'Forms 1',
                  category: 'forms',
                  content: html,
                  media:
                    '<svg viewBox="0 0 32 32"><path d="M22 17h-5v5a1.001 1.001 0 01-2 0v-5h-5a1.001 1.001 0 010-2h5v-5a1.001 1.001 0 012 0v5h5a1.001 1.001 0 010 2zM16 0C7.163 0 0 7.16 0 16s7.163 16 16 16 16-7.16 16-16S24.837 0 16 0z" /></svg>',
                });
              });
            },
          ],
          storage: {
            type: 'self',
            onSave: async ({ project }: { project: any }) => {
              console.log('Project saved', { project });
            },

            onLoad: async () => {
              // TODO load from api
              return {
                project: {
                  pages: [{ name: 'Home', component: '<h1>New project</h1>' }],
                },
              };
            },
          },
          licenseKey: 'DEV_LICENSE_KEY',
        }}
      />
    </div>
  );
};

export default EditorPage;
